export default "__VITE_ASSET__TLR$koJ$__"